import { Check, Gift } from "lucide-react";
import { fmtDate } from "../../lib/adminApi";

export const PerksTable = ({ rows, busy, onHonour }) => (
  <table data-testid="admin-perks-table" className="w-full text-left text-sm">
    <thead>
      <tr className="border-b border-forest/10 text-xs font-bold uppercase tracking-[0.15em] text-forest/50">
        <th className="px-6 py-4">Email</th>
        <th className="px-6 py-4">Milestone</th>
        <th className="px-6 py-4">Perk</th>
        <th className="px-6 py-4">Unlocked</th>
        <th className="px-6 py-4">Status</th>
      </tr>
    </thead>
    <tbody>
      {rows.length === 0 && (
        <tr>
          <td colSpan={5} className="px-6 py-10 text-center text-forest/40">
            No perks unlocked yet — they appear when a referrer hits 5 or 10 invites.
          </td>
        </tr>
      )}
      {rows.map((r) => (
        <tr
          key={`${r.leadId}-${r.milestone}`}
          className="border-b border-forest/5 font-semibold text-forest last:border-0"
        >
          <td className="px-6 py-4">{r.email}</td>
          <td className="px-6 py-4">
            <span className="rounded-full bg-fresh/10 px-3 py-1 text-xs font-bold text-fresh">
              {r.milestone} invites
            </span>
          </td>
          <td className="px-6 py-4">
            <span className="inline-flex items-center gap-2 text-forest/80">
              <Gift className="h-3.5 w-3.5 text-fresh" /> {r.perk}
            </span>
          </td>
          <td className="px-6 py-4 text-forest/60">{fmtDate(r.unlocked_at)}</td>
          <td className="px-6 py-4">
            {r.honoured ? (
              <span
                data-testid={`perk-honoured-${r.leadId}-${r.milestone}`}
                className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-800"
              >
                Honoured
              </span>
            ) : (
              <button
                type="button"
                disabled={busy === `${r.leadId}-${r.milestone}`}
                data-testid={`perk-honour-${r.leadId}-${r.milestone}`}
                onClick={() => onHonour(r.leadId, r.milestone)}
                className="inline-flex items-center gap-1.5 rounded-full bg-forest px-4 py-1.5 text-xs font-bold text-bone transition-colors hover:bg-fresh disabled:opacity-50"
              >
                <Check className="h-3 w-3" /> Mark honoured
              </button>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
